import { Box, Button, CardMedia, Typography } from "@mui/material";
import React, { useMemo, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import agua from "../../image/agua.png";
import axios from "axios";
import Land_pozo from "../../image/Land_pozo.png";
import { setInformacion } from "../../store/slices/usuarios";
import { Alerta } from "../ux/Alert";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc.js";
import { recolectarSevice } from "../../services/recolectarSevice";
import { rutas } from "../../rutas/rutas";
import { getCookie } from "../../utils/getCookies";
import { tierras } from "../niveles/tierras";
import { Construccion } from "./Construccion";
import { SubirNivelButton } from "./botones/SubirNivelButton";
import { Contador } from "../comun/Contador";
import PetBenefitDisplay from "./PetBenefitDisplay";

dayjs.extend(utc);

/* =========================
   UI PRO FX (SOLO VISUAL)
   - NO cambia layout ni lógica
   ========================= */

const uiFx = {
  "@keyframes glowPulse": {
    "0%": { filter: "drop-shadow(0 0 0 rgba(120,200,255,0))" },
    "50%": { filter: "drop-shadow(0 0 14px rgba(120,200,255,.20))" },
    "100%": { filter: "drop-shadow(0 0 0 rgba(120,200,255,0))" },
  },
  "@keyframes floatSlow": {
    "0%": { transform: "translateY(0px)" },
    "50%": { transform: "translateY(-6px)" },
    "100%": { transform: "translateY(0px)" },
  },
  "@keyframes shimmerBtn": {
    "0%": { transform: "translateX(-120%) skewX(-12deg)", opacity: 0 },
    "15%": { opacity: 0.22 },
    "35%": { opacity: 0.10 },
    "100%": { transform: "translateX(220%) skewX(-12deg)", opacity: 0 },
  },
  "@keyframes softFlicker": {
    "0%, 100%": { opacity: 1 },
    "50%": { opacity: 0.95 },
  },
  "@keyframes scanline": {
    "0%": { transform: "translateY(-120%)", opacity: 0 },
    "15%": { opacity: 0.16 },
    "50%": { opacity: 0.10 },
    "100%": { transform: "translateY(120%)", opacity: 0 },
  },
  // Burbujas (agua vibe) — CSS puro
  "@keyframes bubbleRise": {
    "0%": { transform: "translateY(30px) scale(0.95)", opacity: 0 },
    "10%": { opacity: 0.22 },
    "100%": { transform: "translateY(-520px) scale(1.12)", opacity: 0 },
  },
  "@keyframes bubbleRise2": {
    "0%": { transform: "translateY(40px) scale(0.9)", opacity: 0 },
    "10%": { opacity: 0.18 },
    "100%": { transform: "translateY(-560px) scale(1.18)", opacity: 0 },
  },
};

const rootFxSx = {
  ...uiFx,
  position: "relative",
  width: "100%",
  height: "100%",
  overflow: "hidden",
  filter: "saturate(1.05) contrast(1.02)",
  "&::before": {
    // iluminación/vignette con tono azul
    content: '""',
    position: "absolute",
    inset: 0,
    pointerEvents: "none",
    background:
      "radial-gradient(70% 60% at 50% 25%, rgba(120,200,255,0.10), transparent 60%)," +
      "radial-gradient(120% 90% at 50% 60%, rgba(0,0,0,0.18), rgba(0,0,0,0.52))",
    mixBlendMode: "screen",
    zIndex: 0,
  },
  "&::after": {
    // grain retro suave
    content: '""',
    position: "absolute",
    inset: 0,
    pointerEvents: "none",
    backgroundImage:
      "url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"160\" height=\"160\"><filter id=\"n\"><feTurbulence type=\"fractalNoise\" baseFrequency=\"0.8\" numOctaves=\"3\" stitchTiles=\"stitch\"/></filter><rect width=\"160\" height=\"160\" filter=\"url(%23n)\" opacity=\"0.22\"/></svg>')",
    opacity: 0.085,
    mixBlendMode: "overlay",
    zIndex: 0,
  },
};

const scanlineFxSx = {
  position: "absolute",
  inset: 0,
  pointerEvents: "none",
  zIndex: 1,
  "&::before": {
    content: '""',
    position: "absolute",
    inset: 0,
    background:
      "linear-gradient(transparent 0%, rgba(255,255,255,0.03) 50%, transparent 100%)",
    opacity: 0.2,
    animation: "scanline 5.4s linear infinite",
  },
};

const panelFxSx = {
  position: "relative",
  overflow: "hidden",
  boxShadow: "0 18px 40px rgba(0,0,0,.30)",
  transform: "translateZ(0)",
  "&::after": {
    // brillo interior con toque azul
    content: '""',
    position: "absolute",
    inset: 0,
    pointerEvents: "none",
    background:
      "radial-gradient(60% 45% at 50% 15%, rgba(255,255,255,0.06), transparent 55%)," +
      "linear-gradient(180deg, rgba(120,200,255,0.08), transparent 35%, rgba(0,0,0,0.14))",
  },
};

const invTextSx = {
  color: "white !important",
  fontSize: "0.7rem !important",
  textAlign: "start",
  mt: 1,
  textShadow: "0 0 10px rgba(0,0,0,.35)",
};

const titleSx = {
  display: "block",
  fontSize: "1.5rem !important",
  textAlign: "center !important",
  color: "white !important",
  textShadow:
    "0 0 10px rgba(255,255,255,0.16), 0 0 18px rgba(120,200,255,0.18), 0 8px 16px rgba(0,0,0,.22)",
  animation: "softFlicker 2.8s ease-in-out infinite",
  letterSpacing: "1px",
};

const lvlUpSx = {
  fontSize: "1rem !important",
  color: "greenyellow !important",
  textShadow: "0 0 14px rgba(173,255,47,.22)",
  animation: "glowPulse 3.4s ease-in-out infinite",
};

const btnFxSx = {
  position: "relative",
  overflow: "hidden",
  transition: "transform .12s ease, filter .12s ease",
  "&:hover": {
    transform: "translateY(-1px) scale(1.01)",
    filter: "brightness(1.08)",
  },
  "&:active": {
    transform: "translateY(0px) scale(0.98)",
    filter: "brightness(0.98)",
  },
  "&::after": {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    height: "100%",
    width: "42%",
    background:
      "linear-gradient(90deg, transparent, rgba(255,255,255,0.20), transparent)",
    animation: "shimmerBtn 2.9s ease-in-out infinite",
    pointerEvents: "none",
  },
};

// Burbujas (no ocupan espacio, no mueven layout)
function BubbleFX({ density = 12 }) {
  const items = useMemo(() => Array.from({ length: density }), [density]);

  return (
    <Box sx={{ position: "absolute", inset: 0, pointerEvents: "none", zIndex: 1 }}>
      {items.map((_, idx) => {
        const left = Math.round(Math.random() * 100);
        const delay = (Math.random() * 4).toFixed(2);
        const dur = (4 + Math.random() * 5).toFixed(2);
        const size = 4 + Math.round(Math.random() * 10);
        const anim = idx % 2 === 0 ? "bubbleRise" : "bubbleRise2";
        return (
          <Box
            key={idx}
            sx={{
              position: "absolute",
              bottom: -30,
              left: `${left}%`,
              width: size,
              height: size,
              borderRadius: "50%",
              border: "1px solid rgba(140,220,255,0.16)",
              background:
                "radial-gradient(circle at 30% 30%, rgba(255,255,255,0.10), rgba(120,200,255,0.05))",
              boxShadow: "0 0 12px rgba(120,200,255,0.08)",
              opacity: 0,
              animation: `${anim} ${dur}s linear ${delay}s infinite`,
            }}
          />
        );
      })}
    </Box>
  );
}

/* =========================
   COMPONENTE (MISMA LÓGICA)
   ========================= */

export const Agua = ({ selector, handleClose: handleClose2 }) => {
  const [semillas, setSemillas] = useState(1);
  const [error, setError] = useState(false);
  const [open, setOpen] = useState(false);
  const [mensaje, setMensaje] = useState("");
  const { informacion } = useSelector((state) => state.userSlice);
  const dispatch = useDispatch();

  const handleClose = () => setOpen(false);
  const handleChange = (e) => {
    const cantidad = parseInt(e.target.value);
    // if(cantidad > selector?.nivel)return
    setSemillas(cantidad);
  };

  const recolectarSemilla = async () => {
    try {
      const { data } = await recolectarSevice(selector?.id);
      dispatch(setInformacion(data));
      setError(false);
      setMensaje("SUCCESS");
      setOpen(true);
    } catch (error) {
      setError(true);
      setOpen(true);
      setMensaje(
        error?.response?.data?.error ||
          (error?.code === "ECONNABORTED"
            ? "The server took too long to respond. Please try again."
            : "Network error. Please try again.")
      );
    }
  };

  const activarAgua = async () => {
    try {
      const token = getCookie("token");
      const { data } = await axios({
        url: rutas.activarAgua,
        data: { id: 8 },
        method: "post",
        headers: {
          token: token,
        },
        timeout: 15000,
      });

      dispatch(setInformacion(data));
      setError(false);
      setMensaje("SUCCESS");
      setOpen(true);
    } catch (error) {
      setError(true);
      setOpen(true);
      console.log(error);
      setMensaje("ERROR");
    }
  };

  // Solo visual: para “pulso” del botón harvest cuando hay producción disponible (MISMA condición que ya usas)
  const canHarvest =
    Math.floor(
      dayjs().utc().diff(selector?.tiempo, "second") /
        (selector.tiempoProduccion * 3600)
    ) > 0;

  /* =========================
     ✅ NUEVO: IMÁGENES POR NIVEL + PREVIEW
     ========================= */

  const LEVEL_IMAGES = useMemo(
    () => [
    "https://res.cloudinary.com/dpwv380jp/image/upload/v1767287128/lvl1_mgtynd.png",
    "https://res.cloudinary.com/dpwv380jp/image/upload/v1767287129/lvl2_rchvkc.png",
    "https://res.cloudinary.com/dpwv380jp/image/upload/v1767287131/lvl3_fzeegn.png",
    "https://res.cloudinary.com/dpwv380jp/image/upload/v1767287129/lvl4_yvysld.png",
    "https://res.cloudinary.com/dpwv380jp/image/upload/v1767287130/lvl5_rlqhcf.png",
    ],
    []
  );

  // Config de la tierra desde tu array
  const landCfg = useMemo(
    () => tierras.find((t) => t.id === selector?.id),
    [selector?.id]
  );

  // Nivel seleccionado en el menú inferior
  const [previewLevel, setPreviewLevel] = useState(selector?.nivel || 1);

  // Mantener sincronizado al abrir modal o subir nivel
  useEffect(() => {
    setPreviewLevel(selector?.nivel || 1);
  }, [selector?.id, selector?.nivel]);

  const maxLevel = LEVEL_IMAGES?.length || 5;
  const nextLevelReal = Math.min((selector?.nivel || 1) + 1, maxLevel);

  // Requisitos para llegar al "previewLevel"
  const reqForPreviewLevel = useMemo(() => {
    if (!landCfg?.nivel) return null;
    if (previewLevel <= 1) return null;
    const idx = previewLevel - 2; // lvl2->0, lvl3->1, ...
    return landCfg.nivel[idx] || null;
  }, [landCfg, previewLevel]);

  return (
    <Box sx={rootFxSx}>
      {/* FX overlays - NO cambian layout */}
      <BubbleFX density={12} />
      <Box sx={scanlineFxSx} />

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          position: "relative !important",
          overflow: "auto !important",
          width: "100%",
          height: "100%",
          zIndex: 2,
        }}
      >
        <Construccion selector={selector} />

        <PetBenefitDisplay
          type="water"
          icon="💧"
          label="Extra Water"
        />

        {/* Close: misma ubicación (solo corregí typo 'abolute' para que funcione) */}
        <Box
          onClick={handleClose2}
          sx={{
            position: "absolute",
            right: 14,
            top: 10,
            zIndex: 10001,
            color: "white",
            cursor: "pointer",
            fontSize: "14px",
            textShadow: "0 0 10px rgba(0,0,0,.7)",
            opacity: 0.85,
            transition: "all .12s ease",
            "&:hover": { opacity: 1, transform: "scale(1.06)" },
          }}
        >
          X
        </Box>

        <Box
          class="rpgui-container framed-golden"
          sx={{ position: "relative !important", ...panelFxSx }}
        >
          <Typography variant="p" sx={invTextSx}>
            Inventory:
          </Typography>
          <Typography variant="p" sx={invTextSx}>
            Energy:{" "}
            <span style={{ color: "#ffd27f" }}>
              {
                informacion?.inventario.find((i) => i?.item === "Energy")
                  ?.cantidad
              }
            </span>
          </Typography>
          <Typography variant="p" sx={invTextSx}>
            Water:{" "}
            <span style={{ color: "#7fe7ff" }}>
              {
                informacion?.inventario.find((i) => i?.item === "Water")
                  ?.cantidad
              }
            </span>
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            width: "100%",
            height: "100%",
            flexDirection: { xs: "column", md: "row" },
            overflow: "auto !important",
            width: "100%",
            height: "100%",
          }}
        >
          {/* =========================
              IZQUIERDA (MISMO CONTENEDOR)
              ✅ NUEVO: Imagen grande + menú niveles + requisitos + botón
             ========================= */}
          <Box
            class="rpgui-container framed-golden"
            sx={{
              position: "relative !important",
              width: "40%",
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
              flexDirection: "column",
              height: "70vh",
              ...panelFxSx,
              gap: 1,
              pt: 2,
            }}
          >
            {/* ✅ Imagen grande del nivel seleccionado */}
            <Box
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                px: 1,
              }}
            >
              <CardMedia
                className="rpgui-cursor-grab-open"
                component="img"
                image={LEVEL_IMAGES?.[Math.max(0, (previewLevel || 1) - 1)]}
                sx={{
                  width: "64%",
                  maxHeight: "260px",
                  objectFit: "contain",
                  m: "0 auto",
                  animation: "floatSlow 3.4s ease-in-out infinite",
                  filter: "drop-shadow(0 16px 10px rgba(0,0,0,.30))",
                  userSelect: "none",
                }}
              />
            </Box>

            {/* ✅ Menú inferior con todos los niveles */}
            <Box
              sx={{
                width: "100%",
                px: 1.5,
                display: "flex",
                gap: 1,
                overflowX: "auto",
                pb: 0.5,
                "&::-webkit-scrollbar": { height: 6 },
                "&::-webkit-scrollbar-thumb": {
                  background: "rgba(255,255,255,0.18)",
                  borderRadius: 999,
                },
              }}
            >
              {Array.from({ length: maxLevel }).map((_, i) => {
                const lvl = i + 1;
                const isActive = lvl === previewLevel;
                const isOwned = lvl <= (selector?.nivel || 1);
                const isNext = lvl === nextLevelReal;

                return (
                  <Box
                    key={lvl}
                    onClick={() => setPreviewLevel(lvl)}
                    className="rpgui-cursor-point"
                    sx={{
                      minWidth: 64,
                      height: 54,
                      borderRadius: 1,
                      border: isActive
                        ? "2px solid rgba(173,255,47,0.85)"
                        : "1px solid rgba(255,255,255,0.18)",
                      boxShadow: isActive
                        ? "0 0 18px rgba(173,255,47,0.18)"
                        : "0 8px 18px rgba(0,0,0,0.22)",
                      position: "relative",
                      overflow: "hidden",
                      cursor: "pointer",
                      flex: "0 0 auto",
                      transform: isActive
                        ? "translateY(-1px)"
                        : "translateY(0px)",
                      transition: "all .12s ease",
                      "&:hover": { filter: "brightness(1.08)" },
                    }}
                  >
                    <CardMedia
                      component="img"
                      image={LEVEL_IMAGES?.[i]}
                      sx={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        opacity: isOwned ? 1 : 0.78,
                      }}
                    />

                    {/* Badge LVL */}
                    <Box
                      sx={{
                        position: "absolute",
                        left: 4,
                        top: 4,
                        px: 0.7,
                        py: 0.15,
                        borderRadius: 0.8,
                        background: "rgba(0,0,0,0.55)",
                        color: "white",
                        fontSize: "0.65rem",
                        textShadow: "0 0 10px rgba(0,0,0,.45)",
                      }}
                    >
                      LVL {lvl}
                    </Box>

                    {/* Estado */}
                    {isNext && (
                      <Box
                        sx={{
                          position: "absolute",
                          right: 4,
                          bottom: 4,
                          px: 0.6,
                          py: 0.1,
                          borderRadius: 0.8,
                          background: "rgba(173,255,47,0.18)",
                          border: "1px solid rgba(173,255,47,0.35)",
                          color: "greenyellow",
                          fontSize: "0.62rem",
                        }}
                      >
                        NEXT
                      </Box>
                    )}

                    {!isOwned && !isNext && (
                      <Box
                        sx={{
                          position: "absolute",
                          right: 4,
                          bottom: 4,
                          px: 0.6,
                          py: 0.1,
                          borderRadius: 0.8,
                          background: "rgba(0,0,0,0.45)",
                          border: "1px solid rgba(255,255,255,0.12)",
                          color: "rgba(255,255,255,0.85)",
                          fontSize: "0.62rem",
                        }}
                      >
                        LOCK
                      </Box>
                    )}
                  </Box>
                );
              })}
            </Box>

            {/* ✅ Requisitos + botón */}
            <Box
              sx={{
                width: "100%",
                px: 2,
                pb: 1,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 0.8,
              }}
            >
              <Typography variant="p" sx={lvlUpSx}>
                +LVL UP{" "}
                <div
                  style={{ backgroundSize: "100%", width: "30px", height: "30px" }}
                  class="rpgui-icon exclamation"
                />
              </Typography>

              {reqForPreviewLevel ? (
                <Box sx={{ width: "100%" }}>
                  <Typography
                    variant="p"
                    sx={{
                      fontSize: "0.75rem !important",
                      color: "white !important",
                      textShadow: "0 0 10px rgba(0,0,0,.35)",
                      opacity: 0.9,
                    }}
                  >
                    Requisitos para llegar a{" "}
                    <span style={{ color: "#d6ff6b" }}>LVL {previewLevel}</span>:
                  </Typography>

                  {Object.entries(reqForPreviewLevel).map(([k, v]) => (
                    <Typography
                      key={k}
                      variant="p"
                      sx={{
                        fontSize: "0.7rem !important",
                        textAlign: "start",
                        color: "white !important",
                        textShadow: "0 0 10px rgba(0,0,0,.35)",
                      }}
                    >
                      {`${k}: ${v}`}
                    </Typography>
                  ))}
                </Box>
              ) : (
                <Typography
                  variant="p"
                  sx={{
                    fontSize: "0.75rem !important",
                    color: "rgba(255,255,255,0.85) !important",
                    textShadow: "0 0 10px rgba(0,0,0,.35)",
                  }}
                >
                  Selecciona un nivel mayor para ver requisitos.
                </Typography>
              )}

              {/* Botón SOLO cuando seleccionas el siguiente nivel real */}
              {previewLevel === nextLevelReal &&
              nextLevelReal > (selector?.nivel || 1) ? (
                <Box sx={{ mt: 0.5, "& .rpgui-button": btnFxSx }}>
                  <SubirNivelButton
                    setError={setError}
                    setMensaje={setMensaje}
                    setOpen={setOpen}
                    selector={selector}
                  />
                </Box>
              ) : (
                <Typography
                  variant="p"
                  sx={{
                    fontSize: "0.7rem !important",
                    color: "rgba(255,255,255,0.75) !important",
                    textShadow: "0 0 10px rgba(0,0,0,.35)",
                    textAlign: "center",
                  }}
                >
                  Para subir, selecciona el nivel{" "}
                  <span style={{ color: "#d6ff6b" }}>NEXT</span>.
                </Typography>
              )}
            </Box>
          </Box>

          {/* =========================
              DERECHA (SIN CAMBIOS)
             ========================= */}
          <Box
            class="rpgui-container framed-golden"
            sx={{
              position: "relative !important",
              ml: 1,
              width: "50%",
              height: "70vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              ...panelFxSx,
            }}
          >
            <Typography variant="p" sx={titleSx}>
              Water Well
            </Typography>

            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "start",
                width: "100%",
                height: "100%",
                flexDirection: "column",
              }}
            >
              <Box sx={{ width: "100%", display: "flex", justifyContent: "center", ml: 1 }}>
                <CardMedia
                  className="rpgui-cursor-grab-open"
                  component="img"
                  image={agua}
                  sx={{
                    width: "70px",
                    objectFit: "cover",
                    filter: "drop-shadow(0 16px 10px rgba(0,0,0,.30))",
                    animation: "glowPulse 3.0s ease-in-out infinite",
                  }}
                />
              </Box>

              <Typography
                variant="p"
                sx={{
                  fontSize: "1rem !important",
                  textAlign: "start",
                  color: "white !important",
                  textShadow: "0 0 10px rgba(0,0,0,.35)",
                }}
              >
                LVL: <span style={{ color: "#d6ff6b" }}>{selector?.nivel}</span>
              </Typography>
              <Typography
                variant="p"
                sx={{
                  fontSize: "1rem !important",
                  textAlign: "start",
                  color: "white !important",
                  textShadow: "0 0 10px rgba(0,0,0,.35)",
                }}
              >
                Yield: <span style={{ color: "#7fe7ff" }}>{selector?.maximo}</span>{" "}
                Water
              </Typography>
              <Typography
                variant="p"
                sx={{
                  fontSize: "1rem !important",
                  textAlign: "start",
                  color: "white !important",
                  textShadow: "0 0 10px rgba(0,0,0,.35)",
                }}
              >
                Water: <span style={{ color: "#7fe7ff" }}>{selector?.produccion}</span>{" "}
                x {selector?.tiempoProduccion}hours
              </Typography>
              <Typography
                variant="p"
                sx={{
                  fontSize: "1rem !important",
                  textAlign: "start",
                  color: "white !important",
                  textShadow: "0 0 10px rgba(0,0,0,.35)",
                }}
              >
                To harvest you need:{" "}
                <span style={{ color: "#ffd27f" }}>{selector?.costo}</span> Energy x
                Water
              </Typography>

              <Typography
                variant="p"
                sx={{
                  fontSize: "1rem !important",
                  textAlign: "center",
                  color: "white !important",
                  textShadow: "0 0 10px rgba(0,0,0,.35)",
                }}
              >
                harvest:{" "}
                <span style={{ color: "#7fe7ff" }}>
                  {Math.floor(
                    dayjs().utc().diff(selector?.tiempo, "second") /
                      (selector.tiempoProduccion * 3600)
                  ) <= selector?.maximo
                    ? Math.floor(
                        dayjs().utc().diff(selector?.tiempo, "second") /
                          (selector.tiempoProduccion * 3600)
                      )
                    : selector?.maximo}
                </span>
              </Typography>

              <Typography sx={{ color: "white", textShadow: "0 0 10px rgba(0,0,0,.35)" }}>
                Last claim: {selector?.tiempo}
              </Typography>

              <Typography sx={{ display: "flex", color: "white", textShadow: "0 0 10px rgba(0,0,0,.35)" }}>
                Next Water:&nbsp;
                <Contador
                  segundos={dayjs()
                    .utc()
                    .add(
                      (3600 * selector?.tiempoProduccion) -
                        (dayjs().utc().diff(selector?.tiempo, "second") %
                          (3600 * selector?.tiempoProduccion)),
                      "second"
                    )
                    .format()}
                />
              </Typography>

              <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
                {selector?.tiempo === "" && (
                  <Button class="rpgui-button" onClick={activarAgua} sx={btnFxSx}>
                    <p>Turn on water pump</p>
                  </Button>
                )}

                {Math.floor(
                  dayjs().utc().diff(selector?.tiempo, "second") /
                    (selector.tiempoProduccion * 3600)
                ) > 0 && (
                  <Button
                    class="rpgui-button"
                    onClick={recolectarSemilla}
                    sx={{
                      ...btnFxSx,
                      animation: "glowPulse 1.8s ease-in-out infinite",
                    }}
                  >
                    <p>harvest</p>
                  </Button>
                )}
              </Box>
            </Box>

            <Alerta mensaje={mensaje} open={open} handleClose={handleClose} error={error} />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
